export enum GameStatus {
  Loading = 'LOADING',
  Ready = 'READY',
  Start = 'START',
  Calibrating = 'CALIBRATING',
  Playing = 'PLAYING',
  Paused = 'PAUSED',
  Finished = 'FINISHED',
}

export interface GameInfo {
  name: string
  duration: number
  topScores: number[]
}

export interface GameState {
  instructions: string
  status: GameStatus
  prevStatus?: GameStatus
  score: number
}

export interface GameContainerDimensions {
  height: number
  width: number
}
